import SkyXInformationPage from './SkyXInformationPage.container';

export default SkyXInformationPage;
